import { Box, Typography } from "@mui/material"
import { t } from "i18next"

const CopyrightItem = () => {
    let version =
        process.env.REACT_APP_ENV === "prod"
            ? process.env.REACT_APP_VERSION
            : process.env.REACT_APP_VERSION?.substring(0, 7)

    return (
        <Box sx={{ my: 1, ml: 1 }} textAlign="left">
            <Typography variant="caption" ml={1}>
                {`© ${new Date().getFullYear().toString()}, ${t(
                    "copyrightTitle"
                )} | ${version} beta`}
            </Typography>
        </Box>
    )
}
export default CopyrightItem
